module.exports = __webpack_public_path__ + "img/MDS.0976ae04.svg";